import { render, staticRenderFns } from "./EnviarAvisoModal.vue?vue&type=template&id=10421d66"
import script from "./EnviarAvisoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EnviarAvisoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports